import { IBucketProduct } from 'featureSliced/shared/store/reducers/QRMenuBucketReducer/types'
import { roundValueTo } from 'featureSliced/shared/utils/roundValueTo'

/**
 * The cart stores a menu's components per menu (a menu added twice keeps `count: 1`
 * on every component); everything that reads a Click&Collect order — the server total,
 * the CashAssist Beleg, the kitchen ticket, the SmartCheckout — reads them as absolute.
 * Converts at the order boundary; a weighed head keeps its components per line.
 */
export const toAbsoluteMenuCounts = (line: IBucketProduct): IBucketProduct => {
  const components = Array.isArray(line.menuItems) ? line.menuItems : []
  const factor = Number(line.count) || 0
  if (!components.length || line.addedAsWeight || factor <= 0 || factor === 1) {
    return line
  }
  return {
    ...line,
    menuItems: components.map((component: any) => ({
      ...component,
      count: roundValueTo((Number(component.count) || 0) * factor, 0.1),
      ...(component.total !== undefined && component.total !== null
        ? { total: roundValueTo((Number(component.total) || 0) * factor) }
        : {}),
    })),
  }
}
